<template>
  <div class="max-w-lg">
    <h1 class="text-lg font-bold mb-5">Нууц үг солих</h1>
    <my-input v-model="oldPassword" autofocus type="password" label="Хуучин нууц үг"></my-input>
    <my-input v-model="newPassword" type="password" label="Шинэ нууц үг"></my-input>
    <my-input v-model="confirmPassword" type="password" label="Нууц үг давтах"></my-input>
    <div class="p-5 space-x-4">
      <my-button :loading="saving" type="primary" icon="check" @click="handleSave">Хадгалах</my-button>
      <my-button icon="x" @click="handleBack">Буцах</my-button>
    </div>
  </div>
</template>
<script>
export default {
  data () {
    return {
      saving: false,
      oldPassword: '',
      newPassword: '',
      confirmPassword: ''
    }
  },
  methods: {
    async handleSave () {
      try {
        this.saving = true
        await this.axios.post('auth/password', {
          oldPassword: this.oldPassword,
          newPassword: this.newPassword,
          confirmPassword: this.confirmPassword
        })
        this.oldPassword = ''
        this.newPassword = ''
        this.confirmPassword = ''
        this.showToast('Амжилттай нууц үг солилоо.')
      } catch (err) {
        this.handleError(err)
      } finally {
        this.saving = false
      }
    },
    handleBack () {
      this.$router.push({ path: '/' })
    }
  }
}
</script>
